let baseurl = ""//测试地址
// console.log(process.env, 'process.env')
switch (process.env.NODE_ENV) {
  case 'local':
    // baseurl = 'https://test.rongxinchain.com/' // 测试地址
    baseurl = 'http://192.168.1.97:10131/' // 炳会本地
    break
  case 'development'://开发环境
    if (window) {
      // window.console.log = function () {}
    }
    // baseurl="https://test.rongxinchain.com/"//测试地址
    baseurl="https://app.rongxinchain.com/"//正式地址
    // baseurl = 'http://192.168.1.97:10131/' // 炳会本地
    

    break
  case 'production'://生产环境
    if (window) {
      window.console.log = function () { }
      baseurl="https://app.rongxinchain.com/"//正式地址
    }
    break
}
export default {
  baseurl,
}